export default __webpack_public_path__ + "media/images/up_down-9c7ab1180f9a4f714be410eb8675543f.png";